import { useGetMemberHeader } from 'common/queries/member-module';

import { useUserInfo } from 'hooks/auth/useUserInfo';

export const useCheckPrivateMember = () => {
  const { data: selectedMemberProfile } = useGetMemberHeader(
    {
      memberId: null,
    },
    { enabled: false }
  );
  const isPrivateMember =
    selectedMemberProfile?.memberType?.toLowerCase() === 'private member' ||
    selectedMemberProfile?.memberType?.toLowerCase() === 'shared only';

  return isPrivateMember;
};

export const useCheckSharedOnlyMyCompany = () => {
  let { userInfo } = useUserInfo();
  const isSharedOnlyMember =
    userInfo?.member?.memberType?.toLowerCase() === 'manufacturer' ||
    userInfo?.member?.memberType?.toLowerCase() === 'shared only';
  return isSharedOnlyMember;
};
